module.exports = __webpack_public_path__ + "img/hotsys_3.a212f8fb.png";